import { login, refreshAccess } from '../lib/api';
import createRequestActions, {
  createRequestActionNames,
} from './createRequestActions';
import { logout } from '../lib/crossover';

/**
 * A utility function to perform request and refresh token in required
 *
 * @see Usage at: teams.js (loadTeams)
 */
export function withRefresh(name, { payload, fetch, retry }) {
  return function(dispatch, getState) {
    const { login } = getState();

    if (!login.access) return dispatch(refreshToken(retry()));

    const actions = createRequestActions(name);

    dispatch(actions.request(payload));
    fetch(login.access)
      .then(result => dispatch(actions.success(result)))
      .catch(error => {
        const data = error.response && error.response.data;
        if (data && data.code === 'token_not_valid') {
          dispatch(refreshToken(retry()));
        } else {
          dispatch(actions.error(error));
        }
      });
  };
}

const initialState = {
  userData: null,
  access: null,
  refresh: null,
};

// State selectors
// export const isAuthenticated = state => (state.refresh ? true : false);
export const isAuthenticated = state => false;

// Action names
const SIGN_OUT = '[login] signOut';

// Action names
export const [
  LOGIN_REQUEST,
  LOGIN_REQUEST_SUCCESS,
  LOGIN_REQUEST_FAILURE,
] = createRequestActionNames('[login] login');
export const [
  REFRESH_REQUEST,
  REFRESH_REQUEST_SUCCESS,
  REFRESH_REQUEST_FAILURE,
] = createRequestActionNames('[login] refresh');

// Internal actions
const _login = createRequestActions('[login] login');
const _refresh = createRequestActions('[login] refresh');

// Public actions
export const signOut = () => dispatch => {
  logout();
  dispatch({ type: SIGN_OUT });
};

export const logIn = (email, password) => dispatch => {
  dispatch(_login.request(email));

  login(email, password)
    .then(response => dispatch(_login.success(response)))
    .catch(error => dispatch(_login.error(error)));
};

export const refreshToken = nextAction => (dispatch, getState) => {
  const { login } = getState();
  if (!login.refresh) return dispatch(signOut());

  dispatch(_refresh.request());
  refreshAccess()
    .then(response => {
      dispatch(_refresh.success(response));
      if (nextAction) dispatch(nextAction);
    })
    .catch(() => dispatch(signOut()));
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case LOGIN_REQUEST:
      return { ...state, email: payload, access: null, refresh: null };
    case LOGIN_REQUEST_SUCCESS:
      return {
        ...state,
        access: payload.access,
        refresh: payload.refresh,
      };
    case REFRESH_REQUEST_SUCCESS:
      return { ...state, access: payload.access };
    case SIGN_OUT:
      return initialState;
    default:
      return state;
  }
}
